import React from 'react'
import _ from 'lodash'
import classnames from 'classnames'

import arise from '@src/images/logos/partners/arise'
import ficci from '@src/images/logos/partners/ficci'
import niti from '@src/images/logos/partners/niti.png'
import china from '@src/images/logos/partners/china'
import iflytek from '@src/images/logos/partners/iflytek.png'
import steam from '@src/images/logos/partners/steam.png'
import kemenag from '@src/images/logos/partners/kemenag.png'
import rumah from '@src/images/logos/partners/rumah.png'
import vnies from '@src/images/logos/partners/vnies.jpg'

const hashMap = {
  ID: [
    {src: kemenag, href: "https://kemenag.go.id/"},
    {src: rumah, href: "https://belajar.kemdikbud.go.id/bdr/"}
  ],

  VN: [
    {src: vnies, href: "http://vnies.edu.vn", text: "Đồng tổ chức tại địa phương"},
    {src: steam, href: "https://steamacademy.edu.vn/", text: "Đối tác"}
  ],

  CN: [
    {src: china, href: "http://www.gov.cn/xinwen/2019-12/25/content_5464005.htm"},
    {src: iflytek, href: "https://www.iflytek.com/en/"}
  ],

  IN: [
    {src: niti, href: "https://www.aim.gov.in/"},
    {src: arise, href: "https://ficciarise.org/"},
    {src: ficci, href: "hhttp://ficci.in/"}
  ]
}

const Partner = ({ item }) => {
  return (
    <div className="partners-section__wrapper">
      <div>
        <a href={item.href} target="_blank" rel="noopener" className="partners-section__item">
          <img className="partners-section__logo" src={item.src} />
        </a>
        { item.text ? (
            <div className="f--default f--md mt-gutter-s text-center">
              Đồng tổ chức tại địa phương
            </div>
          ) : null
        }
      </div>
   </div>
  )
}

const Partners = (props) => {
  const items = hashMap[window.COUNTRY]
  if (!items || !items.length) { return null }

  const classes = classnames(
    "section", "partners-section",
    {"partners-section--extra-padding": !!props.extraPadding}
  )

  return (
    <section className={classes} id="partners">
      <h1 className="plate-heading plate-heading--left">
        { I18n.t('landing.partners') }
      </h1>
      <div
        className={
          classnames(
            "h-flex-layout", "h-flex-layout--row-inline",
            "h-flex-layout--wrap", "partners-section__content"
          )
        }
      >
        { _.map(items, (item, i) => <Partner key={`partner_${i}`} item={item} />) }
      </div>
    </section>
  )
}

export default Partners
